import React from 'react'

const About = () => {
  return (
    <section className="section about-section">
      <h1 className="section-title">About us</h1>
      <p>L'application vous propose des cocktails du monde entier. Le cocktail est un mélange de boisson alcoolisée. Le mélange peut être constitué par des boisson spiritueuses, des jus de fruits, des sirops ou de la crème. Ils sont préparés individuellement avec de la glace dans un shaker, un verre à mélange ou directement dans un verre à cocktail et servis.</p>
    </section>
  )
}

export default About